import { getLocalePrefs, type UiLocale } from '@/lib/locale';
import { enUS } from './messages/en-US';
import { es } from './messages/es';
import { ptBR, type MessageKey } from './messages/pt-BR';

export type { MessageKey };

const catalogs: Record<UiLocale, Record<MessageKey, string>> = {
  'pt-BR': ptBR,
  es,
  'en-US': enUS,
};

/** Overrides vindos da API (manager) — aplicados por cima do dicionário estático. */
let runtimeOverrides: Partial<Record<UiLocale, Record<string, string>>> = {};

export function setRuntimeMessageOverrides(
  locale: UiLocale,
  messages: Record<string, string>,
): void {
  runtimeOverrides = {
    ...runtimeOverrides,
    [locale]: messages,
  };
}

type Vars = Record<string, string | number>;

function interpolate(template: string, vars?: Vars): string {
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (_, key: string) =>
    vars[key] != null ? String(vars[key]) : `{${key}}`,
  );
}

/** Traduz chave com o `uiLocale` ativo (fora de React: usa getLocalePrefs). */
export function t(key: MessageKey, vars?: Vars, locale?: UiLocale): string {
  const ui = locale ?? getLocalePrefs().uiLocale;
  const override = runtimeOverrides[ui]?.[key];
  const dict = catalogs[ui] ?? ptBR;
  const template = override ?? dict[key] ?? ptBR[key] ?? key;
  return interpolate(template, vars);
}

export function hasTranslation(key: MessageKey, locale: UiLocale): boolean {
  return Boolean(runtimeOverrides[locale]?.[key] || catalogs[locale]?.[key]);
}
